
{
  "familyId": "GET-NEGATIEF-PLUS",
  "questions": [
    {
      "id": "GET-NEGATIEF-PLUS-001",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "multiple_choice",
      "question": "Wat is −3 + 7?",
      "options": ["4", "−4", "10", "−10"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": -4,
            "end": 5,
            "marked": [-3],
            "step": 1,
            "label": "Begin bij −3 op de getallenlijn"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Optellen bij een negatief getal",
            "content": "Begin bij −3 op de getallenlijn en ga 7 stappen naar rechts (optellen = naar rechts). Je passeert 0 en komt op 4.",
            "icon": "lightbulb"
          }
        },
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": -4,
            "end": 5,
            "marked": [-3],
            "highlight": [4],
            "arrows": [{"from": -3, "to": 4, "label": "7 stappen naar rechts"}],
            "step": 1,
            "label": "−3 + 7 = 4: je passeert 0 en komt op 4"
          }
        }
      ],
      "conceptId": "negatief_plus_positief",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.78,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.negatief-houdt-negatief", "label": "Denkt dat het antwoord negatief moet zijn", "optionIndex": 1 },
          { "id": "get.negatief-genegeerd", "label": "Negeert het minteken (3+7=10)", "optionIndex": 2 },
          { "id": "get.beide-negatief", "label": "Behandelt beide getallen als negatief", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Begin bij −3 op de getallenlijn en ga 7 stappen naar rechts. Je passeert 0 en komt op 4. Het positieve getal (7) is groter dan het negatieve (3), dus het antwoord is positief.",
        "solutionSteps": [
          "Begin bij −3 op de getallenlijn",
          "Ga 7 stappen naar rechts (optellen)",
          "−3 → −2 → −1 → 0 → 1 → 2 → 3 → 4",
          "Antwoord: −3 + 7 = 4"
        ],
        "distractorExplanations": {
          "0": "Goed! −3 + 7 = 4. Je begint bij −3 en gaat 7 naar rechts, voorbij 0.",
          "1": "Je dacht waarschijnlijk dat het antwoord negatief moet zijn omdat je met een negatief getal begint. Maar 7 is groter dan 3, dus je komt boven nul uit: −3 + 7 = 4.",
          "2": "Je hebt 3 + 7 = 10 gerekend. Maar −3 + 7 is niet hetzelfde als 3 + 7. Je begint 3 onder nul: 7 − 3 = 4.",
          "3": "Je dacht waarschijnlijk dat beide getallen negatief worden. Maar het is −3 + 7 (een positief getal optellen), niet −3 + (−7)."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-PLUS-002",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "multiple_choice",
      "question": "Wat is −5 + (−3)?",
      "options": ["−8", "−2", "8", "2"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": -9,
            "end": 0,
            "marked": [-5],
            "step": 1,
            "label": "Begin bij −5 op de getallenlijn"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Twee negatieve getallen optellen",
            "content": "Een negatief getal optellen = aftrekken. −5 + (−3) = −5 − 3 = −8. Twee negatieve getallen optellen geeft een nóg negatiever getal.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "negatief_plus_negatief",
      "variantIndex": 2,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.negatief-plus-negatief-aftrekken", "label": "Behandelt + (−3) als − (−3)", "optionIndex": 1 },
          { "id": "get.mintekens-vallen-weg", "label": "Denkt dat twee min een plus geeft", "optionIndex": 2 },
          { "id": "get.haakjes-negeren", "label": "Negeert het minteken in (−3)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Een negatief getal optellen is hetzelfde als aftrekken: −5 + (−3) = −5 − 3 = −8. Op de getallenlijn: begin bij −5 en ga 3 stappen naar links.",
        "solutionSteps": [
          "Herken: + (−3) = − 3",
          "−5 − 3 = −(5 + 3) = −8",
          "Antwoord: −8"
        ],
        "distractorExplanations": {
          "0": "Goed! −5 + (−3) = −8.",
          "1": "Je hebt waarschijnlijk + (−3) verward met − (−3) = +3. Het is hier optellen van −3, dus −5 − 3 = −8.",
          "2": "Twee mintekens vallen niet weg bij optellen. Pas op: −5 + (−3) = −8, niet 8.",
          "3": "Je hebt (−3) gelezen als +3 zonder minteken. Maar de haakjes betekenen: tel −3 op."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-PLUS-003",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "thermometer_slider",
      "question": "Vannacht was het −8°C. Overdag wordt het 12 graden warmer. Wat is de nieuwe temperatuur?",
      "options": [],
      "correctAnswer": 4,
      "data": {
        "minTemp": -15,
        "maxTemp": 15,
        "startTemp": -8,
        "step": 1,
        "unit": "C"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "thermometer",
          "showWhen": "wrong",
          "data": {
            "minTemp": -15,
            "maxTemp": 15,
            "currentTemp": -8,
            "targetTemp": 4,
            "unit": "C",
            "label": "Van −8°C naar 4°C: 12 graden stijging"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Temperatuurstijging = optellen",
            "content": "Stijging van 12 graden vanaf −8°C: −8 + 12 = 4°C. Je passeert het vriespunt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "negatief_plus_context_temperatuur",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "De temperatuur begint bij −8°C en stijgt 12 graden. Stijging = optellen: −8 + 12 = 4°C. Je passeert 0°C.",
        "solutionSteps": [
          "Begint bij −8°C",
          "Stijging van 12 graden = + 12",
          "−8 + 12 = 4",
          "Antwoord: 4°C"
        ]
      }
    },
    {
      "id": "GET-NEGATIEF-PLUS-004",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "multiple_choice",
      "question": "Wat is 6 + (−9)?",
      "options": ["−3", "3", "−15", "15"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": -4,
            "end": 7,
            "marked": [6],
            "step": 1,
            "label": "Begin bij 6 op de getallenlijn"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Een negatief getal optellen = aftrekken",
            "content": "6 + (−9) = 6 − 9. Begin bij 6 en ga 9 stappen naar links: je komt op −3.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "positief_plus_negatief",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.absoluut-verschil-positief", "label": "Pakt het verschil positief (9−6=3)", "optionIndex": 1 },
          { "id": "get.alles-negatief", "label": "Maakt alles negatief: −(6+9)", "optionIndex": 2 },
          { "id": "get.haakjes-negeren", "label": "Negeert het minteken", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "6 + (−9) = 6 − 9 = −3. Het negatieve getal (9) is groter dan het positieve (6), dus het antwoord is negatief.",
        "solutionSteps": [
          "+ (−9) = − 9",
          "6 − 9 = −3",
          "Antwoord: −3"
        ],
        "distractorExplanations": {
          "0": "Goed! 6 + (−9) = −3.",
          "1": "Je hebt 9 − 6 = 3 gerekend, maar bent het minteken vergeten. Het antwoord is negatief: −3.",
          "2": "Je hebt 6 en 9 opgeteld en alles negatief gemaakt. Maar 6 + (−9) = 6 − 9, niet −(6+9).",
          "3": "Je hebt (−9) gelezen als +9. Maar de haakjes betekenen: tel −9 op."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-PLUS-005",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "fill_in",
      "question": "Een onderzeeër bevindt zich op −230 meter (onder zeeniveau). Hij stijgt 175 meter. Op welke hoogte (in meters t.o.v. zeeniveau) bevindt hij zich nu? Typ alleen het getal (positief of negatief).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["-55", "−55"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stijgen = optellen",
            "content": "Stijgen vanaf een diepte: −230 + 175. Het negatieve getal (230) is groter dan het positieve (175), dus de onderzeeër zit nog steeds onder water: −55 m.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "negatief_plus_context_diepte",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "De onderzeeër zit op −230 m en stijgt 175 m: −230 + 175 = −55 m. Hij is dus 175 m omhoog gegaan, maar nog niet aan de oppervlakte — hij zit nog 55 m onder zeeniveau.",
        "solutionSteps": [
          "Startdiepte: −230 m",
          "Stijgen = + 175",
          "−230 + 175 = −(230 − 175) = −55",
          "Antwoord: −55 m (nog onder water)"
        ]
      }
    },
    {
      "id": "GET-NEGATIEF-PLUS-006",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "fill_in",
      "question": "Bereken: −12 + 8 + (−5). Typ het antwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["-9", "−9"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stap voor stap optellen",
            "content": "Werk van links naar rechts. Eerst −12 + 8 = −4. Dan −4 + (−5) = −4 − 5 = −9.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "negatief_plus_meerstaps",
      "variantIndex": 6,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Werk van links naar rechts: −12 + 8 = −4 (positief getal 8 is kleiner dan negatief 12, dus nog negatief). Dan −4 + (−5) = −4 − 5 = −9.",
        "solutionSteps": [
          "Stap 1: −12 + 8 = −4",
          "Stap 2: −4 + (−5) = −4 − 5",
          "−4 − 5 = −9",
          "Antwoord: −9"
        ]
      }
    },
    {
      "id": "GET-NEGATIEF-PLUS-007",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "true_false_series",
      "question": "Beoordeel elke stelling.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "Als je een positief getal optelt bij een negatief getal, wordt het antwoord altijd negatief.", "isTrue": false },
          { "text": "−7 + (−4) is hetzelfde als −7 − 4.", "isTrue": true },
          { "text": "Als |positief getal| > |negatief getal|, is het antwoord positief.", "isTrue": true },
          { "text": "0 + (−6) = 6.", "isTrue": false },
          { "text": "Bij −9 + 9 is het antwoord 0.", "isTrue": true }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Regels voor optellen met negatieve getallen",
            "content": "1) + positief getal = naar rechts. 2) + negatief getal = naar links (= aftrekken). 3) Het antwoord heeft het teken van het getal met de grootste absolute waarde. 4) Tegenovergesteld + tegenovergesteld = 0.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "negatief_plus_regels",
      "variantIndex": 7,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "1) Onwaar: bij −3 + 7 = 4 is het antwoord positief. 2) Waar: + (−4) = − 4. 3) Waar: het teken van het grootste getal wint. 4) Onwaar: 0 + (−6) = −6, niet 6. 5) Waar: tegenovergestelden geven 0.",
        "solutionSteps": [
          "Stelling 1: tegenvoorbeeld −3 + 7 = 4 → ONWAAR",
          "Stelling 2: + (−4) = − 4 → WAAR",
          "Stelling 3: teken van grootste absolute waarde wint → WAAR",
          "Stelling 4: 0 + (−6) = −6, niet 6 → ONWAAR",
          "Stelling 5: −9 + 9 = 0 → WAAR"
        ]
      }
    },
    {
      "id": "GET-NEGATIEF-PLUS-008",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "ordering",
      "question": "Zet deze uitkomsten op volgorde van klein naar groot.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["−4 + 10", "−15 + 8", "−3 + (−9)", "12 + (−6)"],
        "correctOrder": [2, 1, 0, 3]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eerst uitrekenen, dan sorteren",
            "content": "Reken eerst elke som uit, daarna zet je de uitkomsten op volgorde. −4 + 10 = 6, −15 + 8 = −7, −3 + (−9) = −12, 12 + (−6) = 6. Wacht — 6 komt twee keer voor; in dit geval geldt de standaardvolgorde van de items. Eigenlijke uitkomsten: −12, −7, 6, 6.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "negatief_plus_sorteren",
      "variantIndex": 8,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Reken eerst elke som uit. −3 + (−9) = −12 (kleinst), −15 + 8 = −7, −4 + 10 = 6, 12 + (−6) = 6 (gelijk). Volgorde klein → groot: −12, −7, 6, 6.",
        "solutionSteps": [
          "−4 + 10 = 6",
          "−15 + 8 = −7",
          "−3 + (−9) = −12",
          "12 + (−6) = 6",
          "Sorteer: −12 → −7 → 6 → 6"
        ]
      }
    },
    {
      "id": "GET-NEGATIEF-PLUS-009",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "multiple_choice",
      "question": "Een bank toont op een rekening: saldo −€ 45 (rood staan). Er wordt € 30 bijgestort. Daarna gaat er nog € 20 af. Wat is het saldo nu?",
      "options": ["−€ 35", "€ 5", "−€ 5", "−€ 95"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bijstorten = optellen, afhalen = aftrekken",
            "content": "Stap 1: −45 + 30 = −15. Stap 2: −15 − 20 = −35. Saldo is −€ 35.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "negatief_plus_context_saldo",
      "variantIndex": 9,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.saldo-positief-aanname", "label": "Denkt dat bijstorten altijd positief saldo geeft", "optionIndex": 1 },
          { "id": "get.afhalen-na-bijstorten-genegeerd", "label": "Vergeet de tweede afboeking", "optionIndex": 2 },
          { "id": "get.bijstorten-genegeerd", "label": "Vergeet de bijstorting (−45 − 20 = −65… misrekening)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Start: −45. Bijstorting: −45 + 30 = −15. Afboeking: −15 − 20 = −35. Het saldo is −€ 35 (nog steeds rood).",
        "solutionSteps": [
          "Start: −€ 45",
          "+ € 30 → −45 + 30 = −15",
          "− € 20 → −15 − 20 = −35",
          "Antwoord: −€ 35"
        ],
        "distractorExplanations": {
          "0": "Goed! Saldo is −€ 35.",
          "1": "Je hebt 30 + 20 = 50 los gezien van de schuld. Maar je begon met −€ 45, niet met € 0.",
          "2": "Je hebt alleen de bijstorting verwerkt: −45 + 30 = −15. De € 20 afboeking is er nog niet af.",
          "3": "Je hebt waarschijnlijk alle bedragen bij elkaar opgeteld zonder op de plus en min te letten."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-PLUS-010",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "fill_in",
      "question": "Welk getal moet je optellen bij −17 om uit te komen op 5? Typ het getal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["22", "+22"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Omkeerredenering",
            "content": "Je zoekt x in −17 + x = 5. Dat betekent x = 5 − (−17) = 5 + 17 = 22.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "negatief_plus_inverse",
      "variantIndex": 10,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Je zoekt x zodat −17 + x = 5. Tel het verschil: van −17 naar 0 is 17 stappen, van 0 naar 5 is nog 5 stappen → samen 22.",
        "solutionSteps": [
          "−17 + x = 5",
          "Van −17 naar 0: 17 stappen",
          "Van 0 naar 5: 5 stappen",
          "Totaal: 17 + 5 = 22",
          "Antwoord: 22"
        ]
      }
    }
  ]
}
